import React from 'react';
import { ButtonClean } from '@fourthwall/components';
import { routing } from '../../../../../../../../utils/routing';
export const DiscountInfoFields = () => (React.createElement("div", { style: { marginTop: 16 } },
    "In order to activate this perk, you must",
    ' ',
    React.createElement(ButtonClean, { label: "create a shop promo for members", href: routing.promotions.promotionCodes.create.self, target: "_blank" }),
    "inside Promotions tab."));
